import "./dots-loader.scss";

export const DotsLoader = () => {
	return (
		<div className='dots-loader-wrapper'>
			<div className='dots-loader'></div>
		</div>
	);
};
